import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const BiltyEditRoute = lazy(() => import("@/pages/bilty.$id_.edit.page"));

export const Route = createFileRoute("/bilty/$id_/edit")({
  component: BiltyEditRoute,
});
